import React from "react";

export type StructuredDataPayload =
  | Record<string, unknown>
  | Array<Record<string, unknown>>;

export const renderStructuredDataScript = (
  id: string,
  data?: StructuredDataPayload
): React.ReactElement | null =>
  data
    ? React.createElement(
        "script",
        {
          id,
          type: "application/ld+json",
        },
        JSON.stringify(data)
      )
    : null;
